/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Output_Language_LabelInputs */

const en_ad_output_language_label = /** @type {(inputs: Ad_Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output Language`)
};

const fr_ad_output_language_label = /** @type {(inputs: Ad_Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue de sortie`)
};

const de_ad_output_language_label = /** @type {(inputs: Ad_Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgabesprache`)
};

const it_ad_output_language_label = /** @type {(inputs: Ad_Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingua di output`)
};

const ru_ad_output_language_label = /** @type {(inputs: Ad_Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Язык вывода`)
};

const es_ad_output_language_label = /** @type {(inputs: Ad_Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma de salida`)
};

const zh_cn2_ad_output_language_label = /** @type {(inputs: Ad_Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输出语言`)
};

const ja_ad_output_language_label = /** @type {(inputs: Ad_Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力言語`)
};

const hi_ad_output_language_label = /** @type {(inputs: Ad_Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आउटपुट भाषा`)
};

const pt_pt2_ad_output_language_label = /** @type {(inputs: Ad_Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma de saída`)
};

/**
* | output |
* | --- |
* | "Output Language" |
*
* @param {Ad_Output_Language_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_output_language_label = /** @type {((inputs?: Ad_Output_Language_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Output_Language_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_output_language_label(inputs)
	if (locale === "de") return de_ad_output_language_label(inputs)
	if (locale === "it") return it_ad_output_language_label(inputs)
	if (locale === "ru") return ru_ad_output_language_label(inputs)
	if (locale === "es") return es_ad_output_language_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_output_language_label(inputs)
	if (locale === "ja") return ja_ad_output_language_label(inputs)
	if (locale === "hi") return hi_ad_output_language_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_output_language_label(inputs)
	return en_ad_output_language_label(inputs)
});